import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  type = 'website',
  image = 'https://expert-handyman.co.uk/images/logo.png',
  schema
}) => {
  const siteTitle = 'Expert-Handyman';
  const fullTitle = title 
    ? `${title} | ${siteTitle}` 
    : `${siteTitle} | Door Fitting, Painting, Decorating & Handyman Near Me | Manchester & Cheshire`;
  const defaultDescription = 'Local handyman services in Manchester & Cheshire. Door fitting & hanging, skirting boards, architraves, wall panelling, sanding, painting, decorating, plumbing, electrics & plastering. No VAT. Save 30-60%. Free quotes.';
  const defaultKeywords = 'handyman near me, door fitting near me, door hanging near me, skirting board fitting near me, architrave fitting near me, wall panelling near me, painting near me, decorating near me, plumbing near me, electrics near me, plastering near me, handyman Manchester, handyman Cheshire, carpenter near me, local handyman';
  const baseUrl = 'https://expert-handyman.co.uk';
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      {canonical && <link rel="canonical" href={`${baseUrl}${canonical}`} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:site_name" content="Expert-Handyman" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={image} />

      {/* Additional schema if provided */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
